import { render, staticRenderFns } from "./customTransferCmp.vue?vue&type=template&id=64896bf1&"
import script from "./customTransferCmp.vue?vue&type=script&lang=ts&"
export * from "./customTransferCmp.vue?vue&type=script&lang=ts&"
import style0 from "./customTransferCmp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports